import {ArticleDetails} from "../../core/models/interfaces/article-details.interface";
import {ArticleFormSchemaType} from "../constants/article-form-schema";

export function mapArticleDetailsToSchema(articleData: ArticleDetails): ArticleFormSchemaType {
    return {
        title: articleData.title,
        summary: articleData.summary,
        content: articleData.content,
        tags: articleData.tags,
        relatedArticles: articleData.relatedArticles.map(article => ({
            id: article.id,
            title: article.title
        })),
        isVisible: articleData.isVisible,
        specialists: articleData.recommendedSpecialists.map(specialist => ({
            id: specialist.id,
            fullName: specialist.fullName,
        })),
        authorId: articleData.author?.id!,
        authorName: articleData.author?.fullName,
        exercises: articleData.exercises ?? [],
    };
}

